import { render, staticRenderFns } from "./AccountTabAllUsersComments.vue?vue&type=template&id=6d2ef7b4&scoped=true"
import script from "./AccountTabAllUsersComments.vue?vue&type=script&lang=js"
export * from "./AccountTabAllUsersComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ef7b4",
  null
  
)

export default component.exports